import React from 'react';
// import PropTypes from 'prop-types';
import {Row, Col} from 'react-bootstrap';
import * as Day from './Day.Components';
import {jsUcfirst} from '../util/utils';
import '../styles/css/dashboard2.css';

function detailType(content, set, handlers){
  let set_type = null;

  let {type, is_test} = content
  if (!is_test){
    if(type==='dialog'){
      set_type = <Day.Dialogue dataSet={set} />;
    }else if(type==='pattern'){
      set_type = <Day.Pattern dataSet={set} handler={handlers.onPatternClick}/>;
    }else if(type==='voca'){
      set_type = <Day.Vocabulary dataSet={set} />;
    }
  }else {
    if(type==='dialog'){
      set_type = <Day.DialogueQuiz dataSet={set} />;
    }else if(type==='pattern'){
      set_type = <Day.PatternQuiz dataSet={set} />;
    }else if(type==='voca'){
      set_type = <Day.VocaQuiz dataSet={set} />;
    }
  }
  return set_type;
}

export const DayInfoDetail = (props)=> {
  let {content, handlers, weekStatus} = props;
  return(
    <Row className="detail_table_background">
      <Col xs={12} md={10} mdOffset={1} style={{overflow:'visible'}}>
        <div className="detail_table">
          <Row className="detail_title">
            <Col xs={12}>
              <span>
                {content.type!=='quiz'&&jsUcfirst(content.type)} {content.is_test?'Quiz':'Practice'}
              </span>
              {content.date?
                (<span className="title_date">{' - '+content.date}</span>):null}
            </Col>
          </Row>
          {content.is_test?
            weekStatus.is_done?
              content.type==='quiz'?
              <div className="detail_content">
                <Day.Quiz {...props} />
              </div>:
              content.sets.map((set, index)=>(
                <div className="detail_content" key={"detail_content_"+index}>
                  {detailType(content, set, handlers)}
                </div>
              ))
            :<div className="detail_content text-left">
              クイズを進行し、その結果を下から確認してください。
             </div>
          :content.sets.map((set, index)=>(
            <div className="detail_content" key={"detail_content_"+index}>
              {detailType(content, set, handlers)}
            </div>
          ))}
        </div>
      </Col>
    </Row>
  );
};

export const DayInfoTitle = ({week, title, day}) =>{
  return(
    <Row className='table_title'>
      <Col xs={12} md={10} mdOffset={1}>
        <div className="title_padding">
          <div className="title_text">
            <div className="week">
              <span>Week {week}: {title}</span>
            </div>
            <div className="day">
              <span>{jsUcfirst(day)}</span>
            </div>
          </div>
          {/* <div className="musio_activation">
            <button>Start in Musio</button>
          </div> */}
        </div>
      </Col>
    </Row>
  )
}

export const TrainingTitle = ({session_num})=>{
  return(
    <Row className='table_title'>
      <Col xs={12} md={10} mdOffset={1}>
        <div className="title_padding">
          <div className="title_text">
            <div className="week">
              <span>AI Training</span>
            </div>
            <div className="day">
              <span>Session {session_num}</span>
            </div>
          </div>
          {/* <div className="musio_activation">
            <button>Start in Musio</button>
          </div> */}
        </div>
      </Col>
    </Row>
  );
}



// WEBPACK FOOTER //
// ./src/components/DayInfoDetail.js